import { render, staticRenderFns } from "./trial-program.vue?vue&type=template&id=c96587e8&lang=pug&"
import script from "./trial-program.vue?vue&type=script&lang=js&"
export * from "./trial-program.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports